var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.poll = new function () {
    var self = this;
    this.init = function () {
        this.loadPoll();
        this.vote();
    }

    this.loadPoll = function () {

        $('.poll').each(function (index) {
            var pollid = $(this).data("pollid");
            //localStorage.clear();
            self.loadPolls(pollid);
        });
    }

    this.loadPolls = function (pollid) {
        var pollDivId = "#poll-" + pollid;
        var poll = $(pollDivId);
        var pollButton = "#poll-" + pollid + " .poll-vote-button";

        $.ajax({
            url: '/settings/poll-view/',
            type: 'GET',
            cache: false,
            contentType: 'html/text; charset=utf-8',
            dataType: 'html',
            data: { 'pollid': pollid },
            success: function (result) {
                poll.html(result)
                if (localStorage.getItem(pollDivId) == "true"){
                    $(pollButton).hide();
                }
            },
            error: function (data, errorThrown) {
                poll.html('<div>fejl</div>')
            }
        })
    }

    this.vote = function () {

        $('.poll').on("click", '.poll-vote-button', function (event) {
            var pollid = $(this).data("poll");
            var questionid = $(this).data("question");
            var pollDivId = "#poll-" + pollid;
            var pollButton = "#poll-" + pollid + " .poll-vote-button";
            var pollOverlay = "#poll-" + pollid + " .poll-overlay";
            $(pollButton).hide();
            $(pollOverlay).fadeIn("fast");
            $.ajax({
                url: '/settings/poll-post/',
                type: 'GET',
                cache: false,
                contentType: 'html/text; charset=utf-8',
                dataType: 'html',
                data: { 'pollvoteid': questionid },
                success: function (result) {
                    
                    setTimeout(function () {
                        self.loadPolls(pollid);
                    }, 3000);
                    
                    localStorage.setItem(pollDivId, "true");
                },
                error: function (data, errorThrown) {
                    alert("Ups... Der skete vist en fejl!");
                }
            })
        });
    }

} ();






